import { render } from "./Lightsaber.vue?vue&type=template&id=f9b99e82&scoped=true"
import script from "./Lightsaber.vue?vue&type=script&lang=js"
export * from "./Lightsaber.vue?vue&type=script&lang=js"

import "./Lightsaber.vue?vue&type=style&index=0&id=f9b99e82&scoped=true&lang=css"

import exportComponent from "D:\\rober\\RobertVS\\portfolio\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-f9b99e82"]])

export default __exports__